// src/components/OfferPopup.jsx
import React, { useEffect, useState } from 'react';
import './OfferPopup.css';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function OfferPopup() {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [website, setWebsite] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false); // Accordion state

  // 1. Toon popup na 4 seconden
  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  // 2. Body scroll blokkeren
  useEffect(() => {
    if (show) document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [show]);

  // 3. Sluiten
  const handleClose = () => {
    setShow(false);
    setSubmitted(false);
    setEmail('');
    setPhone('');
    setWebsite('');
  };

  // 4. Simuleer e-mailverzending via mailto
  const handleMailto = () => {
    const subject = encodeURIComponent('Gratis groeiscan aanvragen');
    const body = encodeURIComponent(
      `Hallo,

Ik zou graag een gratis groeiscan ontvangen.
Mijn e-mailadres is: ${email}
Telefoonnummer: ${phone}
Website: ${website}

Met vriendelijke groet,`
    );
    window.location.href = `mailto:info@onlinegrowthclub.nl?subject=${subject}&body=${body}`;
    setSubmitted(true);
  };

  // E-mail, telefoon en website validatie
  const isValid = () => {
    return (
      email.includes('@') &&
      phone.trim().length >= 6 &&
      (website.startsWith('http://') || website.startsWith('https://'))
    );
  };

  if (!show) return null;

  return (
    <div className="popup-overlay" role="dialog" aria-modal="true">
      <div className="popup-box">
      <button className="popup-close" onClick={handleClose} aria-label="Sluiten">
        <FontAwesomeIcon icon={faTimes} />
      </button>

        {!submitted ? (
          <>
            <h3 className="popup-title">Ontvang een gratis groeiscan</h3>
            <p className="popup-text">
              Laat je gegevens achter en ontdek binnen 24 uur hoe jouw online zichtbaarheid ervoor staat.
            </p>

            <div className="popup-form">
              <input
                type="email"
                required
                placeholder="Jouw e-mailadres"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                type="tel"
                required
                placeholder="Jouw telefoonnummer"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <input
                type="url"
                required
                placeholder="Jouw website (https://)"
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
              />
              <button
                className="btn btn-orange"
                disabled={!isValid()}
                onClick={handleMailto}
              >
                Aanvragen
              </button>
            </div>

            {/* Accordion */}
            <section className={`popup-info ${infoOpen ? 'open' : ''}`}>
              <button
                className="accordion-toggle"
                onClick={() => setInfoOpen((o) => !o)}
                aria-expanded={infoOpen}
              >
                Wat is een groeiscan?
                <span className="accordion-icon" aria-hidden="true">
                  {infoOpen ? '−' : '+'}
                </span>
              </button>

              <div className="accordion-content">
                <p>
                  Een groeiscan is een gratis en vrijblijvende analyse van jouw online zichtbaarheid.
                  We kijken naar onderdelen zoals:
                </p>
                <ul>
                  <li>Je website</li>
                  <li>Of je goed vindbaar bent op Google (SEO)</li>
                  <li>Je social-media-aanwezigheid</li>
                  <li>Eventuele advertenties (SEA)</li>
                </ul>
                <p>
                  Heb je sommige van deze nog niet? Geen probleem – dan slaan we die gewoon over.
                  Je ontvangt een kort, persoonlijk rapport met praktische tips om online beter zichtbaar
                  te worden en meer klanten aan te trekken.
                </p>
              </div>
            </section>
          </>
        ) : (
          <div className="popup-thankyou">
            <h3 className="popup-title">Bedankt voor je aanvraag!</h3>
            <p className="popup-text">
              Er is een e-mailvoorstel geopend in jouw e-mailprogramma. Verstuur deze e-mail om jouw groeiscan aan te vragen.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
